import { Popover, Space, Tooltip } from 'antd';
import { t } from 'i18next';
import React, { useState } from 'react';

import { updateEmotion } from '../api/updateEmotion.js';
import * as utils from '../utils/utils.js';

// Simple emoji button component
const EmojiButton = ({ emoji, onClick, id }) => {
    const handleClick = () => {
        if (onClick) onClick(id);
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleClick();
        }
    };

    return (
        <div
            onClick={handleClick}
            onKeyDown={handleKeyDown}
            style={{
                display: 'inline-block',
                cursor: 'pointer',
                fontSize: '24px',
                transition: 'transform 0.2s',
            }}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.2)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
            tabIndex={0}
            role="button"
            aria-label="Emotion button"
        >
            {emoji}
        </div>
    );
};

export default function EmoteIconTrigger({
    chatId,
    currentParticipantId,
    refreshChatCallback,
    sendReaction,
}) {
    const [popupOpen, setPopupOpen] = useState(false);

    const hide = () => {
        setPopupOpen(false);
    };

    const handleOpenChange = (newOpen) => {
        setPopupOpen(newOpen);
    };

    const postEmotion = async (id) => {
        let nextEmotionValue = id.slice(-1);

        hide();

        // Send via real-time socket if available, otherwise fallback to traditional API
        if (sendReaction) {
            sendReaction(chatId, currentParticipantId, nextEmotionValue);
        } else {
            // Fallback to traditional API
            await updateEmotion(chatId, currentParticipantId, nextEmotionValue);
            refreshChatCallback();
        }
    };
    const popupContent = (
        <div className="columns">
            <div className="column">
                <Tooltip placement="top" title={t('Like')}>
                    <EmojiButton
                        emoji="👍"
                        onClick={postEmotion}
                        id={'emotion' + utils.EMOTION_LIKE}
                    />
                </Tooltip>
            </div>
            <div className="column">
                <Tooltip placement="top" title={t('Heart')}>
                    <EmojiButton
                        emoji="❤️"
                        onClick={postEmotion}
                        id={'emotion' + utils.EMOTION_HEART}
                    />
                </Tooltip>
            </div>
            <div className="column">
                <Tooltip placement="top" title={t('Happy')}>
                    <EmojiButton
                        emoji="😀"
                        onClick={postEmotion}
                        id={'emotion' + utils.EMOTION_HAPPY}
                    />
                </Tooltip>
            </div>
            <div className="column">
                <Tooltip placement="top" title={t('Sad')}>
                    <EmojiButton
                        emoji="😢"
                        onClick={postEmotion}
                        id={'emotion' + utils.EMOTION_SAD}
                    />
                </Tooltip>
            </div>
        </div>
    );

    return (
        <>
            <span>
                <Space wrap>
                    <Popover
                        placement="bottom"
                        content={popupContent}
                        open={popupOpen}
                        onOpenChange={handleOpenChange}
                        trigger="click"
                    >
                        {/* 👍 */}
                        <span
                            className="like-icon"
                            style={{
                                cursor: 'pointer',
                            }}
                        >
                            {t('Like')}
                            <img
                                src="/img/thumbs-up-simple.svg"
                                width="15"
                                alt="Like"
                                style={{
                                    cursor: 'pointer',
                                    marginLeft: 2,
                                }}
                            />
                        </span>
                    </Popover>
                </Space>
            </span>
        </>
    );
}
